// https://capitalise.atlassian.net/wiki/spaces/PLATFI/pages/2531426514/Legacy+Account+Solution+Integration+Guide
export const IntegrationContext = Object.freeze({
  // called from questionnaire
  marketplace: 'marketplace',
  // called from funding profile cases
  profile: 'profile',
  // called from everywhere else (non-funding profiles cases, cases list, monitor client)
  direct: 'direct',
  client: 'client',
});
